import FullScreenLoader from './FullScreenLoader.jsx';

export default FullScreenLoader;


// WEBPACK FOOTER //
// ./src/components/FullScreenLoader/index.js